/**
 * Modal Cart Threshold
 * Sepet tutarı belirli bir eşiği geçtiğinde modal gösterir
 * Günde en fazla 1 kere gösterilir
 */

class ModalCartThreshold {
  constructor() {
    this.modal = null;
    this.settings = window.modalCartThresholdSettings || {};
    this.storageKey = 'modalCartThresholdShown';
    this.isInitialized = false;
    this.lastCartCheck = null; // Son kontrol edilen cart verisi
    this.checkTimeout = null; // Debounce için

    // Ayarları kontrol et - sadece show_modal kontrolü yap
    if (!this.settings.show_modal) {
      return;
    }

    // Sayfa URL kontrolü
    if (!this.isPageAllowed()) {
      return;
    }

    // show_price boşsa 0 olarak kabul et
    if (!this.settings.show_price) {
      this.settings.show_price = '0';
    }
    this.init();
  }

  isPageAllowed() {
    // Eğer modal_page_url boşsa, tüm sayfalarda göster
    if (!this.settings.modal_page_url || this.settings.modal_page_url.trim() === '') {
      return true;
    }

    // Mevcut sayfa URL'si ile karşılaştır
    const currentUrl = this.settings.current_page_url || window.location.pathname;
    const targetUrl = this.settings.modal_page_url.trim();


    return currentUrl === targetUrl;
  }

  init() {
    if (this.isInitialized) return;

    // Modal HTML'ini oluştur
    this.createModal();

    // Event listener'ları ekle
    this.bindEvents();

    // Sepet kontrolünü başlat
    this.startCartMonitoring();

    this.isInitialized = true;
  }

  createModal() {
    // Modal container'ı oluştur
    this.modal = document.createElement('div');
    this.modal.className = 'modal-cart-threshold';
    this.modal.id = 'modalCartThreshold';

    // Modal içeriğini oluştur
    const modalContent = `
      <div class="modal-cart-threshold-content">
        <button class="modal-cart-threshold-close" type="button" aria-label="Kapat">
          ×
        </button>

        <div class="modal-cart-threshold-left">
          <div class="modal-cart-threshold-header">
            ${this.settings.modal_title ? `
              <h2 class="modal-cart-threshold-title">${this.settings.modal_title}</h2>
            ` : ''}
          </div>

          <div class="modal-cart-threshold-body">
            ${this.settings.modal_content ? `
              <div class="modal-cart-threshold-content-text">
                ${this.settings.modal_content}
              </div>
            ` : ''}
          </div>

          ${this.settings.modal_button_text && this.settings.modal_button_link ? `
            <div class="modal-cart-threshold-footer">
              <a href="${this.settings.modal_button_link}" class="modal-cart-threshold-button">
                ${this.settings.modal_button_text}
              </a>
            </div>
          ` : ''}
        </div>

        ${this.settings.modal_image ? `
          <div class="modal-cart-threshold-right">
            <img src="${this.settings.modal_image}" alt="${this.settings.modal_title || ''}" class="modal-cart-threshold-image">
          </div>
        ` : ''}
      </div>
    `;

    this.modal.innerHTML = modalContent;

    // Body'ye ekle
    document.body.appendChild(this.modal);
  }

  bindEvents() {
    if (!this.modal) return;

    // Kapatma butonuna tıklama
    const closeBtn = this.modal.querySelector('.modal-cart-threshold-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => this.closeModal());
    }

    // Modal dışına tıklama
    this.modal.addEventListener('click', (e) => {
      if (e.target === this.modal) {
        this.closeModal();
      }
    });

    // ESC tuşu
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.modal.classList.contains('show')) {
        this.closeModal();
      }
    });

    // Modal butonuna tıklama
    const modalButton = this.modal.querySelector('.modal-cart-threshold-button');
    if (modalButton) {
      modalButton.addEventListener('click', () => {
        this.closeModal();
      });
    }
  }

  startCartMonitoring() {
    // Sayfa yüklendiğinde mevcut cart durumunu kontrol et
    this.debouncedCartCheck();

    // Cart değişikliklerini dinle - bu event Shopify teması tarafından cart güncellendiğinde tetiklenir
    document.addEventListener('cart:updated', (event) => {
      // Event'te cart verisi varsa onu kullan
      if (event.detail && event.detail.cart) {
        this.checkCartThresholdWithData(event.detail.cart);
      } else {
        // Yoksa debounced check yap
        this.debouncedCartCheck();
      }
    });

    // Form submit'lerini dinle (add to cart formu için)
    document.addEventListener('submit', (event) => {
      const form = event.target;
      // Add to cart formu mu kontrol et
      if (form && form.action && form.action.includes('/cart/add')) {
        // Form submit'inden sonra kısa bir gecikme ile kontrol et
        setTimeout(() => this.debouncedCartCheck(), 500);
      }
    });
    // Ajax cart update'lerini dinle
    this.setupAjaxListeners();
  }

  setupAjaxListeners() {
    // XMLHttpRequest'leri dinle
    const originalXHROpen = XMLHttpRequest.prototype.open;
    const originalXHRSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function(method, url, ...args) {
      this._url = url;
      this._method = method;
      return originalXHROpen.call(this, method, url, ...args);
    };

    XMLHttpRequest.prototype.send = function(data) {
      
      if (this._url && this._url.includes('/cart/')) {
        this.addEventListener('load', () => {
          if (this.status >= 200 && this.status < 300) {
            // Başarılı cart işlemi sonrası kontrol et
            setTimeout(() => {
              window.modalCartThresholdInstance?.debouncedCartCheck();
            }, 200);
          }
        });
      }
      return originalXHRSend.call(this, data);
    };

    // Fetch isteklerini de dinle ama sadece cart işlemleri için
    const originalFetch = window.fetch;
    window.fetch = function(input, init = {}) {
      const url = typeof input === 'string' ? input : input.url;
      const method = init.method || 'GET';

      return originalFetch.call(this, input, init).then(response => {
        // Sadece cart işlemlerini dinle ve GET cart.js isteklerini hariç tut
        if (url && url.includes('/cart/') && method !== 'GET') {
          if (response.ok) {
            setTimeout(() => {
              window.modalCartThresholdInstance?.debouncedCartCheck();
            }, 200);
          }
        }
        return response;
      });
    };
  }

  // Debounced cart check - çok sık çağrılmasını önler
  debouncedCartCheck() {
    if (this.checkTimeout) {
      clearTimeout(this.checkTimeout);
    }

    this.checkTimeout = setTimeout(() => {
      this.checkCartThreshold();
    }, 300); // 300ms debounce
  }

  async checkCartThreshold() {
    try {
      // Modal cooldown süresinde mi kontrol et
      if (this.wasShownRecently()) {
        return;
      }

      // Sepet bilgilerini al
      const cartData = await this.getCartData();
      this.checkCartThresholdWithData(cartData);

    } catch (error) {
      console.error('Modal Cart Threshold Error:', error);
    }
  }

  checkCartThresholdWithData(cartData) {
    if (!cartData) return;

    const cartTotal = cartData.total_price / 100; // Shopify cent cinsinden verir
    const threshold = parseFloat(this.settings.show_price) || 0;


    if (cartTotal >= threshold) {
      // Debug modu: URL'de ?modal_test=1 varsa hemen göster
      const urlParams = new URLSearchParams(window.location.search);
      const isTestMode = urlParams.get('modal_test') === '1';

      if (isTestMode) {
        this.showModal();
      } else {
        // Dinamik delay süresi (dakika cinsinden)
        const delayMinutes = parseInt(this.settings.modal_delay_minutes) || 2;
        const delayMs = delayMinutes * 60 * 1000;

        setTimeout(() => {
          this.showModal();
        }, delayMs);
      }
    } else {
    }
  }

  async getCartData() {
    try {
      // Önce mevcut window.cart verisini kontrol et
      if (window.cart && typeof window.cart === 'object') {
        return window.cart;
      }

      // Son alınan veri çok yeniyse onu kullan (5 saniye içinde)
      if (this.lastCartCheck &&
          this.lastCartCheck.timestamp &&
          Date.now() - this.lastCartCheck.timestamp < 5000) {
        return this.lastCartCheck.data;
      }

      
      const response = await fetch('/cart.js', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      });

      if (!response.ok) {
        throw new Error(`Cart fetch failed: ${response.status}`);
      }

      const cartData = await response.json();

      // Cache'le
      this.lastCartCheck = {
        data: cartData,
        timestamp: Date.now()
      };

      
      return cartData;
    } catch (error) {
      console.error('Cart data fetch error:', error);
      return null;
    }
  }

  showModal() {
    if (!this.modal || this.wasShownRecently()) return;

    // Modal'ı göster
    this.modal.classList.add('show');

    // Body scroll'unu engelle
    document.body.style.overflow = 'hidden';

    // Gösterildi olarak işaretle
    this.markAsShown();

    // Analytics event (opsiyonel)
    if (typeof gtag !== 'undefined') {
      gtag('event', 'modal_cart_threshold_shown', {
        'event_category': 'engagement',
        'event_label': 'cart_threshold_modal'
      });
    }
  }

  closeModal() {
    if (!this.modal) return;

    // Modal'ı gizle
    this.modal.classList.remove('show');

    // Body scroll'unu geri aç
    document.body.style.overflow = '';

    // Analytics event (opsiyonel)
    if (typeof gtag !== 'undefined') {
      gtag('event', 'modal_cart_threshold_closed', {
        'event_category': 'engagement',
        'event_label': 'cart_threshold_modal'
      });
    }
  }

  wasShownRecently() {
    const lastShownTimestamp = localStorage.getItem(this.storageKey);

    if (!lastShownTimestamp) {
      
      return false;
    }

    const lastShownDate = new Date(parseInt(lastShownTimestamp));
    const now = new Date();
    const cooldownDays = parseInt(this.settings.modal_cooldown_days) || 1;
    const cooldownMs = cooldownDays * 24 * 60 * 60 * 1000; // Günü milisaniyeye çevir

    const timeDiff = now.getTime() - lastShownDate.getTime();
    const isInCooldown = timeDiff < cooldownMs;

    // Bir sonraki modal açılma tarihini hesapla
    const nextShowTimestamp = lastShownDate.getTime() + cooldownMs;
    const nextShowDate = new Date(nextShowTimestamp);

    // Türkçe tarih formatı
    const nextShowDateFormatted = nextShowDate.toLocaleDateString('tr-TR', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });


    return isInCooldown;
  }

  markAsShown() {
    const now = new Date().getTime();
    localStorage.setItem(this.storageKey, now.toString());
    
  }

  // Public methods
  destroy() {
    if (this.modal) {
      this.modal.remove();
      this.modal = null;
    }
    if (this.checkTimeout) {
      clearTimeout(this.checkTimeout);
    }
    this.isInitialized = false;
  }

  updateSettings(newSettings) {
    this.settings = { ...this.settings, ...newSettings };
    if (this.modal) {
      this.destroy();
      this.init();
    }
  }
}

// Auto-initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  // Ayarların yüklenmesini bekle
  if (typeof window.modalCartThresholdSettings !== 'undefined') {
    window.modalCartThresholdInstance = new ModalCartThreshold();
  } else {
    // Ayarlar henüz yüklenmediyse biraz bekle
    setTimeout(() => {
      if (typeof window.modalCartThresholdSettings !== 'undefined') {
        window.modalCartThresholdInstance = new ModalCartThreshold();
      }
    }, 100);
  }
});

// Export for module usage
if (typeof module !== 'undefined' && module.exports) {
  module.exports = ModalCartThreshold;
}